var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 300,
    viewBox: "0 200 800 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(217, 25%, 22%)",
    d: "M429.405 350.937c19.768 0 35.793 16.011 35.793 35.761s-16.025 35.76-35.793 35.76-35.793-16.01-35.793-35.76 16.025-35.761 35.793-35.761"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(208, 6%, 40%)",
    d: "M433.474 370.5c9.098 0 16.474 7.351 16.474 16.418s-7.376 16.418-16.474 16.418S417 395.985 417 386.918s7.376-16.418 16.474-16.418"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(217, 25%, 22%)",
    d: "M670.793 351.5c19.768 0 35.793 16.01 35.793 35.76s-16.025 35.761-35.793 35.761S635 407.01 635 387.26s16.025-35.76 35.793-35.76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(208, 6%, 40%)",
    d: "M673.474 370.5c9.098 0 16.474 7.351 16.474 16.418s-7.376 16.418-16.474 16.418S657 395.985 657 386.918s7.376-16.418 16.474-16.418"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(219, 10%, 47%)",
    d: "M363 195.5h274c4.425 0 6 5 6 5l40.197 95.496 45.874 14.711a9 9 0 0 1 6.238 8.077l3.459 62.997a4 4 0 0 1-3.994 4.219H353V206c0-9.497 2.6-10.5 10-10.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#99A3B5",
    d: "M343 195.5h274c4.425 0 6 5 6 5l40.197 95.496 45.874 14.711a9 9 0 0 1 6.238 8.077l3.459 62.997a4 4 0 0 1-3.994 4.219H333V206c0-9.497 2.6-10.5 10-10.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7EFF7",
    d: "M585.859 231.029a4 4 0 0 1 4-4h19.625c1.571 0 2.997.92 3.644 2.352l26.422 58.412c1.198 2.648-.738 5.648-3.644 5.648h-46.047a4 4 0 0 1-4-4ZM638.592 228.391a1 1 0 0 1 .92-1.391h9.156c.807 0 1.535.485 1.846 1.229l26.907 64.385a1 1 0 0 1-.923 1.386h-8.675a2 2 0 0 1-1.841-1.217Z",
    opacity: 0.99
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(218, 20%, 34%)",
    d: "M327 379.238a3 3 0 0 1 2.999-3l33.396-.014c4.95-19.77 22.835-34.412 44.139-34.412 21.291 0 39.167 14.624 44.13 34.375l153.358-.065c4.986-19.718 22.846-34.31 44.114-34.31 21.254 0 39.105 14.574 44.104 34.273l45.759-.019a3 3 0 0 1 3.001 3v4.999a3 3 0 0 1-3 3h-16v-.253H345v.253h-15a3 3 0 0 1-3-3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M408.099 351.219c19.768 0 35.793 16.01 35.793 35.76s-16.025 35.76-35.793 35.76-35.793-16.01-35.793-35.76 16.025-35.76 35.793-35.76"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(208, 8%, 79%)",
    d: "M408.474 370.5c9.098 0 16.474 7.351 16.474 16.418s-7.376 16.418-16.474 16.418S392 395.985 392 386.918s7.376-16.418 16.474-16.418"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M648.422 351.219c19.768 0 35.793 16.01 35.793 35.76s-16.025 35.76-35.793 35.76c-19.767 0-35.792-16.01-35.792-35.76s16.025-35.76 35.792-35.76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "hsl(0, 0%, 98%)",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M362.053 218.543h183M362.053 231.375h183M362.053 244.208h183M362.053 257.04h183M362.053 269.873h183M362.053 282.705h183M362.053 295.538h183",
    opacity: 0.46
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "hsl(218, 12%, 49%)",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M570.519 366.239V227.668M647.5 323l.019-21.332"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#363E4E",
    d: "M737.04 325.431a1 1 0 0 0-.972-.957l-31.94-.878a5 5 0 0 0-5.138 4.998V343a5 5 0 0 0 5 5h17.51l1.5 3h9.5l.5-3h3.957a1 1 0 0 0 .999-1.043Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC8C",
    d: "M719.704 332.75a3 3 0 0 0-2.961-2.779l-9.608-.099a3 3 0 0 0-3.031 2.999v7.425a3 3 0 0 0 2.954 2.999l10.162.155a3 3 0 0 0 3.038-3.221ZM738.137 331.852a2 2 0 0 0-1.994-1.852h-.989a2 2 0 0 0-1.995 2.148l.704 9.5a2 2 0 0 0 1.994 1.852h.989a2 2 0 0 0 1.995-2.148Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(208, 8%, 79%)",
    d: "M648.422 370.561c9.099 0 16.475 7.351 16.475 16.418s-7.376 16.418-16.475 16.418-16.474-7.351-16.474-16.418 7.376-16.418 16.474-16.418"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(217, 14%, 38%)",
    d: "M620 281a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-19a2 2 0 0 1-2-2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(217, 14%, 38%)",
    d: "M620 289a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-26a2 2 0 0 1-2-2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "hsl(210, 10%, 79%)",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M274 172.5s-12.695 12.267-10.5 19 16.726 4.068 14.5 0-15.302 6.686-14.5 14.5 5 15 5 15"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(43, 100%, 41%)",
    d: "m122.5 373.5 24-.233V386.5L144 391l2.5 5.5v24h-24v-12l5-6-5-5.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB600",
    d: "M89.69 373.267h40.81V389l-4.5 6 4.5 7.5v18l-10.202-.058L116 416.5l-5.905 3.883-20.405-.116v-11.75l4.81-6.017-4.81-5.733Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC8C",
    d: "M102 373h15v13h-15Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#D19601",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m94.5 402.5 4.5 5 2.25-2 2.25-2M121.5 389.5l2.5 2.75 2.5 2.75M119.5 395l4.5-2.5M101.5 405.5l3 3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(40, 28%, 76%)",
    d: "m286 280-3.831-10.327.862-6.442-3.106-11.591a5 5 0 0 0-6.124-3.536l-6.42 1.72a5 5 0 0 0-3.705 4.853l.027 5.968-1.02 4.987a1 1 0 0 0 1.238 1.166l1.335-.357 1.577 5.887a1 1 0 0 0 1.127.728l1.877-.307a2 2 0 0 1 2.32 1.857l.343 5.894Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#363E4D",
    d: "M263.5 339.5h31v75H279V359h-2v55.5h-13.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "hsl(0, 0%, 100%)",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M269 344v7.791a6 6 0 0 1-3.317 5.367L263 358.5M288 344v8.791a6 6 0 0 0 3.317 5.367L294 359.5",
    opacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5602F",
    d: "M258.917 284.474a5 5 0 0 1 2.862-1.901l9.024-2.166a2 2 0 0 0 1.523-2.144L272 275h3.087a1 1 0 0 1 .996.909l.417 4.591 2.502-3.441a5 5 0 0 1 4.044-2.059H286v3.142a2 2 0 0 0 1.852 1.995l9.131.676a5 5 0 0 1 3.862 2.322l14.062 22.334a6.03 6.03 0 0 1 .543 5.331l-.169.451a3 3 0 0 1-.897 1.258L300.5 324H291l13-13-7-11 .935 43.936a3 3 0 0 1-2.999 3.064H265a3 3 0 0 1-3-3v-43.5l-9 10.5 13 13h-9.5l-12.533-11.141a4 4 0 0 1-1.248-2.122l-.424-1.908a3 3 0 0 1 .511-2.427Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(219, 19%, 66%)",
    d: "M265 414.5h12v6.5h-26v-3h8.5ZM293 414.5h-14v6.5h23v-3h-6.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "hsl(40, 28%, 76%)",
    d: "m256.5 324-5 2v4H262v-6ZM300 324l5 2v4h-11.5a3 3 0 0 1-3-3v-3Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5C5C",
    d: "m269.346 256.436 2.2 8.21 2.414-.646s.684-4.505 2.122-3.675 1.199 6.408 1.199 6.408L283 263s1.054-4.797-.839-8.962c-.142-1.013-.517-1.932-.517-1.932Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#363E4D",
    d: "m281.882 253.198-.777-2.898s-2.46-7.106-12.083-4.527-6.847 11.152-6.847 11.152l-7.727 2.07.388 1.45Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#363E4E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M277 280v63a5 5 0 0 0 5 5h0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "hsl(0, 0%, 100%)",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m298 303-5-7.5",
    opacity: 0.3
  })));
};
export default SvgNotFound;